import { Drawer } from "antd";
import { useState } from "react";
import close from "./../../../assets/images/close.svg";
import CityList from "./CityList";
import SearchBar from "./SearchByCity";

const CitySheet = ({
  show,
  cities,
  closePopup,
  handleCity,
}: any) => {
  const [searchTerm, setSearchTerm] = useState("");
  const filteredCities = searchTerm
    ? cities?.filter((s: any) =>
      s?.cityName?.toLowerCase().concat(", ").concat(s?.state?.toLowerCase()).includes(searchTerm?.toLowerCase())
    )
    : cities;

  return (
    <Drawer
      placement="bottom"
      onClose={() => {
        setSearchTerm("");
        closePopup();
      }}
      closeIcon={false}
      open={show}
      height="90vh"
      className="rounded-t-2xl overflow-hidden max-h-[90vh]"
      style={{ maxWidth: "1280px", margin: "auto" }}
    >
      <div className="flex flex-col">
        <div className="flex justify-between items-center">
          <div className="font-semibold text-lg">Select City</div>
          <img src={close} alt="close" onClick={closePopup} />
        </div>
      </div>
      <section className="flex flex-col text-base bg-white rounded-3xl w-full">
        <SearchBar value={searchTerm} onChange={setSearchTerm} label={'Search by city name'} />
        <CityList
          onCitySelect={(value) => {
            setSearchTerm("");
            handleCity(value);
          }}
          cities={filteredCities}
        />
      </section>
    </Drawer>
  );
};

export default CitySheet;
